import { envFlag } from 'utils/env';

export const MODULES = {
  RP: envFlag(process.env.REACT_APP_MODULE_RP, false),
  GESTION_PROVEEDORES: envFlag(process.env.REACT_APP_MODULE_GESTION_PROVEEDORES, false),
};
